export const xs = "@media (max-width:599.95px)";
export const sm = "@media (max-width:959.95px)";
export const md = "@media (max-width:1279.95px)";
export const xl = "@media (min-width:0px)";
